import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import get from 'get-value';
import {clearAlerts} from '../../../actions/alertsActions';
import Loader from '../../Loader';
import {
    FORM_BUTTON_ESCALATE,
    FORM_FIELD_TYPE_OF_REQUEST,
    FORM_TICKET_SECTION,
    INTERNAL_TICKET_FORM,
} from '../../../constants/formConstants';
import set from 'set-value';
import formTypeMessages from '../../../intl/common/formTypeMessages';
import {
    initNewTechDocInternalTicket,
    transformNewInternalTicketForSave,
} from '../Utils';
import {createRights} from '../../../constants/techDocInternalTicketRights';
import {createReqFields} from '../../../constants/techDocInternalTicketRequiredFields';
import ValidFormattedMessage from '../../common/ValidFormattedMessage';
import PageHeader from '../../common/PageHeader';
import PropTypes from 'prop-types';
import checkRoles from '../../common/roleChecker/RoleChecker';
import InternalTicketMasterForm from './forms/InternalTicketMasterForm';
import {
    fetchTechDocInternalTicketSgInfo,
    resetTechDocInternalTicket,
    saveTechDocInternalTicket
} from '../../../actions/techDoc/actionTechDocInternalTicket';
import UploadingTechDocInternalTicketAttachments from './UploadingTechDocInternalTicketAttachments';
import {scrollContentWrapperToTop} from '../../../utils/utils';
import {formValueSelector} from 'redux-form';
import alertMessages from '../../../intl/common/alertMessages';
import {injectIntl} from 'react-intl';
import OverlayLoader from '../../OverlayLoader';
import formMessages from '../../../intl/technicalDocumentations/formMessages';
import {closeTechDocDicModal} from '../../../actions/techDoc/actionTechDocDicData';

class NewTechDocInternalTicketPage extends Component {
    constructor(props) {
        super(props);
        this.state = {ticketSubmittedAndShouldRedirect: false};
    }

    componentDidMount() {
        const {userDetail} = this.props;
        this.props.clearAlerts();
        this.props.resetTechDocInternalTicket();
        if (get(userDetail, 'roles.TECHNICAL_DOCUMENTATION.sgEditor.sgPermission', []).length === 1) {
            this.props.fetchTechDocInternalTicketSgInfo(get(userDetail, 'roles.TECHNICAL_DOCUMENTATION.sgEditor.sgPermission.0.id', ''));
        }
        scrollContentWrapperToTop();
    }

    missingEditorsNotes = (submitBy, dataForSend) => {
        if (submitBy === FORM_BUTTON_ESCALATE) {
            return !dataForSend.message;
        }
    }

    handleSubmit = (values) => {
        const {submitBy} = values;
        const editorSolutionGroups = get(this.props.userDetail, 'roles.TECHNICAL_DOCUMENTATION.sgEditor.sgPermission');
        const dataForSend = transformNewInternalTicketForSave(values.newValues, editorSolutionGroups);
        if (this.missingEditorsNotes(submitBy, dataForSend)) {
            if (!window.confirm(this.props.intl.formatMessage(alertMessages.ESCALATION_MISSING_EDITORS_NOTES_GROUP_WARN))) {
                return;
            }
        }
        this.props.saveTechDocInternalTicket(dataForSend);
        this.setState({ticketSubmittedAndShouldRedirect: true});
    };

    render() {
        const {
            formType,
            ticketData,
            attachmentsData,
            group,
            selectedRequestType,
            dicInfo: {isModalActive},
            closeTechDocDicModal
        } = this.props;


        if (Array.isArray(attachmentsData.attachmentsForUpload) && (attachmentsData.attachmentsForUpload.length > 0)) {
            return <UploadingTechDocInternalTicketAttachments attachments={attachmentsData.attachmentsForUpload}
                                                attachmentsUrl={ticketData.newAttachments}
                                                correlationId={ticketData.correlationId}
                                                isAttachmentUploading={attachmentsData.isTicketAttachmentUploading}
                                                formType={formType}/>
        }

        if (this.state.ticketSubmittedAndShouldRedirect && !ticketData.isTicketCreating && !ticketData.isTicketLoading && get(ticketData, 'ticket.uuid', {default: false})) {
            return <Redirect to={{
                pathname: `/documentation/internalTicket/view/${ticketData.ticket.uuid}`,
                redirectedAfterUpdate: true
            }}/>;
        }

        if (!formType
            || this.state.ticketSubmittedAndShouldRedirect
            || ticketData.correlationId
        ) {
            return <Loader/>;
        }

        const initializationValue = initNewTechDocInternalTicket(this.props.userDetail, this.props.location.initData);
        const requiredFields = createReqFields[createReqFields[group] ? group : 'DEFAULT'][selectedRequestType ? selectedRequestType : formType];

        return (
            <div id="ticketPrint" className="container-fluid">
                <PageHeader title={<ValidFormattedMessage message={formType} intlMessages={formTypeMessages}/>}/>
                <div>
                    {formType === INTERNAL_TICKET_FORM &&
                    <InternalTicketMasterForm form={formType}
                                                    initialValues={set(initializationValue, 'ticketSection.docType', INTERNAL_TICKET_FORM)}
                                                    userRights={createRights}
                                                    reqFields={requiredFields}
                                                    enableReinitialize={true}
                                                    handleSubmit={this.handleSubmit}/>
                    }
                </div>
                <OverlayLoader active={isModalActive}
                               text={formMessages.WAIT_DIC}
                               handleClose={closeTechDocDicModal}/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    userDetail: state.profile.userDetail,
    group: state.profile.userDetail.group,
    ticketData: state.techDocInternalTicket,
    attachmentsData: state.techDocInternalTicketAttachment,
    selectedRequestType: formValueSelector(props.formType)(state, `${FORM_TICKET_SECTION}.${FORM_FIELD_TYPE_OF_REQUEST}`),
    dicInfo: state.techDocDic,
});

NewTechDocInternalTicketPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    userDetail: PropTypes.object.isRequired,
    formType: PropTypes.string.isRequired,
    saveTechDocInternalTicket: PropTypes.func.isRequired,
    fetchTechDocInternalTicketSgInfo: PropTypes.func.isRequired,
    ticketData: PropTypes.object.isRequired,
    attachmentsData: PropTypes.object.isRequired,
};

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    saveTechDocInternalTicket,
    resetTechDocInternalTicket,
    fetchTechDocInternalTicketSgInfo,
    closeTechDocDicModal
})(injectIntl(NewTechDocInternalTicketPage))), ["TD_SG_EDITOR"]);

